import React, { forwardRef } from 'react';
import { classNames } from '../../utils/format';

const Input = forwardRef(function Input({ className, invalid, ...rest }, ref) {
  return (
    <input
      ref={ref}
      className={classNames('form-control', invalid && 'is-invalid', className)}
      {...rest}
    />
  );
});

export default Input;
